import { inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { AuthApiService } from '@features/auth/services/auth-api.service';
import { catchError, EMPTY } from 'rxjs';

/**
 * Initializer to avoid showing views to users that logged in
 * previously but whose token has expired. Sends a request
 * to check if the saved token is still valid. If not, the
 * auth interceptor automatically detects 401 and redirects
 * to login.
 */
export function authInitializer() {
  const authApiService = inject(AuthApiService);
  const authService = inject(AuthService);

  const currentToken = authService.token();
  if (currentToken) {
    return authApiService.getUser().pipe(catchError(() => EMPTY));
  }

  return EMPTY;
}
